
import HeaderDashboard from "../../Components/HeaderDashboard";

const CancellationBooking = () => {  


    return (
        <>
            <HeaderDashboard></HeaderDashboard>
            <div className="toolbar py-2" id="kt_toolbar">
                <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1 flex-shrink-0 me-5">
                        <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                            <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Reservations</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li class="breadcrumb-item text-muted">Flight</li>
                                <li class="breadcrumb-item">
                                    <span class="bullet bg-gray-200 w-5px h-2px"></span>
                                </li>

                                <li class="breadcrumb-item text-gray-900">Cancellation Booking</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <section className='wraper'>
                <div className='box_shadow mt-14'>
                    <div class="row mamage_depo">
                        <div class="col-lg-9">
                            <h6 className='ruler'>Flight Re-Schedule</h6>
                        </div>
                        <div class="col-lg-3">
                            <a href="#" onclick="history.back()" class="click_back"><i class="fa fa-arrow-left"></i></a>
                        </div>
                    </div>
                        <div className="col-md-12">
                             <div className='table-responsive'>
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Reference No</th>
                                        <th>Confirmation Number (PNR)</th>
                                        <th>Booking Status</th>
                                        <th>Ticketing Status</th>
                                        <th>Booking Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>D2WFA3247</td>
                                        <td>47M4GY</td>
                                        <td>Hold</td>
                                        <td>OnRequest</td>
                                        <td>Sat 18 Oct , 2025</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        </div>
                    <div className='col-md-12 col-lg-12'>
                        <h6 className='ruler'>Travel Information</h6>
                        <div className='table-responsive'>
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                            <th>Travel Date</th>
                            <th>Flight No.</th>
                            <th>Aircraft Type</th>
                            <th>From / Terminal </th>
                            <th>To / Terminal</th>
                            <th>Dep Time</th>
                            <th>Arr Time</th>
                            <th>Airline</th>
                        </tr>
                                </thead>
                                <tbody>
                                   <tr>
                                    <td>Fri  05 Dec , 2025</td>
                                    <td>
                                        9P - 741
                                    </td>
                                    <td><samp>N/A</samp></td>
                                    <td class="dropdown-caps">SHJ </td>
                                    <td class="dropdown-caps">ISB </td>
                                    <td>05-Dec-2025,09:15,AM</td>
                                    <td>05-Dec-2025,01:10,PM</td>
                                    <td>9P</td>
                                </tr>
                                <tr>
                                    <td>Sat  31 Jan , 2026</td>
                                    <td>
                                        9P - 742
                                    </td>
                                    <td><samp>N/A</samp></td>
                                    <td class="dropdown-caps">ISB </td>
                                    <td class="dropdown-caps">SHJ </td>
                                    <td>31-Jan-2026,08:15,PM</td>
                                    <td>31-Jan-2026,10:50,PM</td>
                                    <td>9P</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className='col-md-12 col-lg-12'>
                        <h6 className='ruler'>Cancel Ticket</h6>
                        <div className='row table-respons'>
                        <div class="col-md-3">
                            <label className="">Reference No</label>                       
                            <div class="datepicker-wrap">
                                <input placeholder="Reference.." type="text" name="selectfromdate" class="form-control" id="txtTransactionFromDate" value="" />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label className="">PNR Number</label>                       
                            <div class="datepicker-wrap">
                                <input placeholder="PNR" type="text" name="selectfromdate" class="form-control" id="txtTransactionFromDate" value="" />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label className="">Booking Status</label>                       
                            <select class="form-select form-select-solid" name="bookingStatus"><option value="">- Select -</option><option value="Confirmed">Confirmed</option><option value="Hold">Hold</option><option value="Failure">Failure</option><option value="Released">Released</option><option value="OnRequest">OnRequest</option><option value="Cancelled">Cancelled</option><option value="Voided">Voided</option></select>
                        </div>
                   
                        <div class="col-md-12">
                            <label className="">Write Comments</label>
                        
                           <textarea className="form-controls" rows="3" placeholder="Comments.."></textarea>
                        </div>
                        <div class="col-md-12">
                            <h5>Select reason for cancel ticket.</h5>
                                <div class="form-check mt-2">
                                    <input type="radio" class="form-check-input" id="radio1" name="optradio" value="option1" />
                                    <label class="form-check-label" for="radio1">Change in travel plans</label>
                                </div>
                                <div class="form-check mt-2">
                                    <input type="radio" class="form-check-input" id="radio2" name="optradio" value="option2" />
                                    <label class="form-check-label" for="radio2">Medical emergency</label>
                                </div>
                                <div class="form-check mt-2">
                                    <input type="radio" class="form-check-input" id="radio3" name="optradio" value="option2" />
                                    <label class="form-check-label" for="radio3">Personal emergency</label>
                                </div>
                                <div class="form-check mt-2">
                                    <input type="radio" class="form-check-input" id="radio4" name="optradio" value="option2" />
                                    <label class="form-check-label" for="radio4">Incorrect booking (wrong date/time)</label>
                                </div>
                                <div class="form-check mt-2">
                                    <input type="radio" class="form-check-input" id="radio5" name="optradio" value="option2" />
                                    <label class="form-check-label" for="radio5">Duplicate booking</label>
                                </div>
                                <div class="form-check mt-2">
                                    <input type="radio" class="form-check-input" id="radio6" name="optradio" value="option2" />
                                    <label class="form-check-label" for="radio6">Visa issues</label>
                                </div>
                                <div class="form-check mt-2">
                                    <input type="radio" class="form-check-input" id="radio7" name="optradio" value="option2" />
                                    <label class="form-check-label" for="radio7">Bad weather concerns</label>
                                </div>
                                <div class="form-check mt-2">
                                    <input type="radio" class="form-check-input" id="radio8" name="optradio" value="option2" />
                                    <label class="form-check-label" for="radio8">Work/official commitments</label>
                                </div>
                                <div class="form-check mt-2">
                                    <input type="radio" class="form-check-input" id="radio9" name="optradio" value="option2" />
                                    <label class="form-check-label" for="radio9">Family event postponed/cancelled</label>
                                </div>
                                <div class="form-check mt-2">
                                    <input type="radio" class="form-check-input" id="radio10" name="optradio" value="option2" />
                                    <label class="form-check-label" for="radio10">Budget issues / fare too high</label>
                                </div>
                                <div class="form-check mt-2">
                                    <input type="radio" class="form-check-input" id="radio11" name="optradio" value="option2" />
                                    <label class="form-check-label" for="radio11">Missed flight</label>
                                </div>
                                <div class="form-check mt-2">
                                    <input type="radio" class="form-check-input" id="radio12" name="optradio" value="option2" />
                                    <label class="form-check-label" for="radio12">Travel companion cancelled</label>
                                </div>
                                <div class="form-check mt-2">
                                    <input type="radio" class="form-check-input" id="radio13" name="optradio" value="option2" />
                                    <label class="form-check-label" for="radio13">Travel restrictions</label>
                                </div>
                                <div class="form-check mt-2">
                                    <input type="radio" class="form-check-input" id="radio14" name="optradio" value="option2" />
                                    <label class="form-check-label" for="radio14">Other (please specify)</label>
                                </div>
                               
                            </div>
                        <div class="col-md-6 mt-5 mb-3">
                            <button type="button" class="btn btn-primary mt-2">Cancel Ticket</button>
                            </div>
                    </div>
                        </div>
                   
                 

                </div>
            </section>
        </>
    );
};

export default CancellationBooking;